export default __webpack_public_path__ + "static/media/img_xendesktop-colorBkg.7d77f514.png";